export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '47fe60ba-b912-4bff-bc6a-c2ccb99492d0';
export const MODAL_CLOSE_SEC = 2.5;